/* FigureIt theme — behaviour layer.
   Everything visual lives in base.css and is driven by the brand-direction
   tokens; this file only handles interaction. */
(function () {
  'use strict';

  var cfg = window.FigureIt || {};

  /* ---------------------------------------------------------
     Brand direction switcher (only rendered when enabled)
     --------------------------------------------------------- */
  var THEMES = [
    { id: 'arcade',    name: '1b · Insert Coin',   tagline: 'LEVEL UP YOUR DESK',            swatch: ['#ff3b30', '#ffcc00', '#3355ff', '#111111'], motif: 'GRID · HI-SCORE' },
    { id: 'cream',     name: '2a · Classic Cream', tagline: 'Print charming.',               swatch: ['#ff4d6d', '#8338ec', '#06d6a0', '#fff6eb'], motif: 'CONFETTI · VANILLA' },
    { id: 'toybox',    name: '1a · Toy Box',       tagline: 'Small batch. Big grin.',        swatch: ['#ff4d6d', '#ffb703', '#06d6a0', '#3a86ff'], motif: 'CONFETTI · CANDY BRIGHTS' },
    { id: 'squish',    name: '1c · Squish',        tagline: 'a little friend for your shelf', swatch: ['#ff7ba3', '#ffc2d4', '#b8f1de', '#dcc9f5'], motif: 'soft blobs · milky pastels' },
    { id: 'printlab',  name: '1d · Print Lab',     tagline: 'Printed. Tuned. Shipped.',      swatch: ['#ff5a1e', '#17b8a6', '#6b6e76', '#f3f2ee'], motif: 'PLA-MATTE · 0.12MM · 32% GYROID' },
    { id: 'afterdark', name: '2b · After Dark',    tagline: 'Prints after midnight.',        swatch: ['#ffb703', '#ff4d6d', '#06d6a0', '#2b2436'], motif: 'CONFETTI · AFTER MIDNIGHT' },
    { id: 'mint',      name: '2c · Mint Fresh',    tagline: 'Fresh off the bed.',            swatch: ['#06d6a0', '#3a86ff', '#ff4d6d', '#fffdf8'], motif: 'CONFETTI · FRESH OFF THE BED' },
    { id: 'sunny',     name: '2d · Sunny Poster',  tagline: 'BIG DROP ENERGY',               swatch: ['#ffb703', '#ff4d6d', '#8338ec', '#2b2436'], motif: 'BIG DROP ENERGY' }
  ];

  var panel = document.getElementById('themePanel');
  var fab = document.getElementById('themeFab');
  var list = document.getElementById('themeList');

  if (panel && fab && list) {
    THEMES.forEach(function (t) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tp-item';
      btn.setAttribute('role', 'option');
      btn.dataset.theme = t.id;
      btn.style.setProperty('--sw-a', t.swatch[0]);
      btn.style.setProperty('--sw-b', t.swatch[1]);
      btn.style.setProperty('--sw-c', t.swatch[2]);
      btn.style.setProperty('--sw-d', t.swatch[3]);
      btn.innerHTML =
        '<span class="tp-sw" aria-hidden="true"><i></i><i></i><i></i><i></i></span>' +
        '<span class="tp-txt"><span class="tp-name"></span><span class="tp-tag"></span></span>';
      btn.querySelector('.tp-name').textContent = t.name;
      btn.querySelector('.tp-tag').textContent = t.tagline;
      btn.addEventListener('click', function () { applyTheme(t.id); });
      list.appendChild(btn);
    });

    var current = function () {
      return document.documentElement.getAttribute('data-theme') || 'cream';
    };

    var applyTheme = function (id) {
      var theme = THEMES.filter(function (t) { return t.id === id; })[0] || THEMES[0];
      document.documentElement.setAttribute('data-theme', theme.id);
      try { localStorage.setItem('figureit.theme', theme.id); } catch (e) {}

      Array.prototype.forEach.call(list.querySelectorAll('.tp-item'), function (el) {
        el.setAttribute('aria-selected', String(el.dataset.theme === theme.id));
      });

      var label = document.getElementById('motifLabel');
      if (label) label.textContent = theme.motif;
    };

    var openPanel = function (open) {
      panel.hidden = !open;
      fab.setAttribute('aria-expanded', String(open));
      if (open) {
        var sel = list.querySelector('[aria-selected="true"]') || list.firstElementChild;
        if (sel) sel.focus();
      }
    };

    fab.addEventListener('click', function () { openPanel(panel.hidden); });
    document.getElementById('themeClose').addEventListener('click', function () {
      openPanel(false);
      fab.focus();
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (!panel.contains(e.target) && !fab.contains(e.target)) openPanel(false);
    });

    document.addEventListener('keydown', function (e) {
      var typing = /^(INPUT|TEXTAREA|SELECT)$/.test((document.activeElement || {}).tagName || '');
      if (e.key === 'Escape' && !panel.hidden) { openPanel(false); fab.focus(); return; }
      if (typing || e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.key === 't' || e.key === 'T') { e.preventDefault(); openPanel(panel.hidden); return; }

      if (['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
      if (panel.hidden && document.activeElement !== fab) return;
      e.preventDefault();
      var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
      var i = 0;
      THEMES.forEach(function (t, idx) { if (t.id === current()) i = idx; });
      var next = THEMES[(i + step + THEMES.length) % THEMES.length];
      applyTheme(next.id);
      var el = list.querySelector('[data-theme="' + next.id + '"]');
      if (el && !panel.hidden) el.focus();
    });

    applyTheme(current());
  }

  /* ---------------------------------------------------------
     Nav
     --------------------------------------------------------- */
  var header = document.getElementById('site-header');
  var navToggle = document.getElementById('navToggle');
  if (header && navToggle) {
    navToggle.addEventListener('click', function () {
      var open = header.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', String(open));
    });
    Array.prototype.forEach.call(document.querySelectorAll('.nav-links a'), function (a) {
      a.addEventListener('click', function () { header.classList.remove('open'); });
    });
  }

  /* ---------------------------------------------------------
     Nav dropdown — click/tap to open (works for touch and desktop alike),
     closes on an outside click or Escape.
     --------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('.nav-drop'), function (drop) {
    var toggle = drop.querySelector('.nav-drop-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = drop.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(open));
      Array.prototype.forEach.call(document.querySelectorAll('.nav-drop.open'), function (other) {
        if (other !== drop) {
          other.classList.remove('open');
          other.querySelector('.nav-drop-toggle').setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
  document.addEventListener('click', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.nav-drop.open'), function (drop) {
      drop.classList.remove('open');
      drop.querySelector('.nav-drop-toggle').setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      Array.prototype.forEach.call(document.querySelectorAll('.nav-drop.open'), function (drop) {
        drop.classList.remove('open');
        drop.querySelector('.nav-drop-toggle').setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ---------------------------------------------------------
     Header auto-hide on scroll (mobile only) — the sticky header
     plus the quicknav strip eat a large share of a phone screen, so
     on small viewports it slides out of the way on scroll-down and
     snaps back on scroll-up, keeping nav one gesture away without
     permanently taxing the viewport.
     --------------------------------------------------------- */
  var header = document.getElementById('site-header');
  if (header) {
    var lastY = window.scrollY;
    var ticking = false;
    var applyHeaderScroll = function () {
      ticking = false;
      if (window.innerWidth > 720) {
        header.classList.remove('is-hidden');
        return;
      }
      var y = window.scrollY;
      if (y > lastY && y > header.offsetHeight) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastY = y;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(applyHeaderScroll);
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', applyHeaderScroll);
  }

  /* ---------------------------------------------------------
     Scroll reveal
     --------------------------------------------------------- */
  var reveal = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(reveal, function (el) { io.observe(el); });
  } else {
    Array.prototype.forEach.call(reveal, function (el) { el.classList.add('in-view'); });
  }

  /* ---------------------------------------------------------
     Hero carousel — slides multiple product photos through the hero
     media slot on a translating track (bouncy easing, matches the
     theme's signature pop). Autoplays, pauses on hover/focus, dots
     are clickable, swipeable on touch. No-op if there's only one slide.
     --------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-hero-carousel]'), function (carousel) {
    var track = carousel.querySelector('.hero-slides-track');
    var slides = carousel.querySelectorAll('.hero-slide');
    var dots = carousel.querySelectorAll('.hero-dot');
    if (!track || slides.length < 2) return;

    var rtl = getComputedStyle(carousel).direction === 'rtl';
    var index = 0;
    var timer = null;

    var goTo = function (i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (rtl ? 1 : -1) * index * 100 + '%)';
      Array.prototype.forEach.call(dots, function (d, di) { d.classList.toggle('is-active', di === index); });
    };

    var start = function () {
      stop();
      timer = window.setInterval(function () { goTo(index + 1); }, 2000);
    };
    var stop = function () { if (timer) { window.clearInterval(timer); timer = null; } };

    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); start(); });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);

    var touchX = null;
    carousel.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) { goTo(index + (dx < 0 ? 1 : -1)); start(); }
      touchX = null;
    });

    start();
  });

  /* ---------------------------------------------------------
     Auto-submitting selects (collection sorting)
     --------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-auto-submit]'), function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* ---------------------------------------------------------
     Product page: gallery, variants, quantity
     --------------------------------------------------------- */
  var productRoot = document.querySelector('[data-product-root]');
  if (productRoot) {
    var hero = productRoot.querySelector('[data-product-hero]');
    var thumbs = productRoot.querySelectorAll('[data-thumb]');

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        var img = hero.querySelector('img');
        if (!img) {
          hero.innerHTML = '<img alt="">';
          img = hero.querySelector('img');
        }
        img.src = thumb.dataset.full;
        img.alt = thumb.dataset.alt || '';
        img.removeAttribute('srcset');
        Array.prototype.forEach.call(thumbs, function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    var dataEl = document.querySelector('[data-variant-data]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var idInput = productRoot.querySelector('[data-variant-id]');
    var addBtn = productRoot.querySelector('[data-add-button]');
    var priceTarget = productRoot.querySelector('[data-price-target]');

    var selectedOptions = function () {
      return Array.prototype.map.call(
        productRoot.querySelectorAll('[data-option-index]'),
        function (group) {
          var on = group.querySelector('[aria-pressed="true"]');
          return on ? on.dataset.optionValue : null;
        }
      );
    };

    var updateVariant = function () {
      var chosen = selectedOptions();
      if (!chosen.length) return;

      var match = variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];

      if (!match) {
        addBtn.disabled = true;
        return;
      }

      idInput.value = match.id;
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? addBtn.dataset.addLabel : addBtn.dataset.soldLabel;

      if (priceTarget) {
        var sale = match.compare_at_price && match.compare_at_price > match.price;
        priceTarget.innerHTML =
          '<span class="price' + (sale ? ' on-sale' : '') + '">' +
          '<span class="amount">' + money(match.price) + '</span>' +
          (sale ? '<s class="compare">' + money(match.compare_at_price) + '</s>' : '') +
          '</span>';
      }

      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    };

    Array.prototype.forEach.call(productRoot.querySelectorAll('[data-option-index] .swatch'), function (sw) {
      sw.addEventListener('click', function () {
        var group = sw.closest('[data-option-index]');
        Array.prototype.forEach.call(group.querySelectorAll('.swatch'), function (s) {
          s.setAttribute('aria-pressed', 'false');
        });
        sw.setAttribute('aria-pressed', 'true');
        updateVariant();
      });
    });

    var qtyInput = productRoot.querySelector('.qty input');
    var stepQty = function (delta) {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, v + delta);
    };
    var up = productRoot.querySelector('[data-qty-up]');
    var down = productRoot.querySelector('[data-qty-down]');
    if (up) up.addEventListener('click', function () { stepQty(1); });
    if (down) down.addEventListener('click', function () { stepQty(-1); });
  }

  /* ---------------------------------------------------------
     Cart drawer + AJAX add to cart
     --------------------------------------------------------- */
  var drawer = document.getElementById('cartDrawer');

  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var close = drawer.querySelector('[data-cart-close]');
      if (close && close.focus) close.focus();
    }
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var empty = drawer.querySelector('[data-cart-empty]');
    var total = drawer.querySelector('[data-cart-total]');

    updateCartCount(cart.item_count);

    if (!cart.items.length) {
      body.innerHTML = '';
      foot.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    foot.hidden = false;
    total.textContent = money(cart.total_price);

    body.innerHTML = cart.items.map(function (item) {
      // Line item properties are how custom orders carry their reference photo.
      var props = Object.keys(item.properties || {})
        .filter(function (k) { return k.charAt(0) !== '_' && item.properties[k]; })
        .map(function (k) {
          var v = item.properties[k];
          var isFile = typeof v === 'string' && v.indexOf('/uploads/') > -1;
          return escapeHtml(k) + ': ' + (isFile
            ? '<a href="' + escapeHtml(v) + '" target="_blank" rel="noopener">file</a>'
            : escapeHtml(v));
        })
        .join('<br>');

      return '' +
        '<div class="cd-item">' +
          (item.image
            ? '<img src="' + escapeHtml(item.image) + '" alt="" width="64" height="64">'
            : '<span></span>') +
          '<div>' +
            '<div class="ci-title">' + escapeHtml(item.product_title) + '</div>' +
            (item.variant_title ? '<div class="ci-variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
            (props ? '<div class="cd-props">' + props + '</div>' : '') +
            '<button type="button" class="cart-remove" data-drawer-remove="' + escapeHtml(item.key) + '">' +
              escapeHtml((cfg.strings || {}).remove || 'Remove') +
            '</button>' +
          '</div>' +
          '<div><span class="price"><span class="amount">' + money(item.final_line_price) + '</span></span>' +
            '<div class="ci-variant" style="text-align:end;">× ' + item.quantity + '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    Array.prototype.forEach.call(body.querySelectorAll('[data-drawer-remove]'), function (btn) {
      btn.addEventListener('click', function () {
        changeCart(btn.dataset.drawerRemove, 0, true);
      });
    });
  }

  function updateCartCount(count) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshDrawer(open) {
    fetch(cfg.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        if (open) openDrawer(true);
      });
  }

  if (drawer) {
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-cart-close]'), function (el) {
      el.addEventListener('click', function () { openDrawer(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) openDrawer(false);
    });

    // Header cart icon opens the drawer instead of navigating.
    var cartLink = document.querySelector('.cart-link');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        refreshDrawer(true);
      });
    }
  }

  // Intercept the product form — unless it carries a file upload, which
  // must go through a real form POST.
  var pForm = document.querySelector('[data-product-form]');
  if (pForm && !pForm.hasAttribute('data-no-ajax')) {
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = pForm.querySelector('[data-add-button]');
      var original = btn.textContent;
      btn.disabled = true;

      fetch(cfg.routes.cart_add, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: new FormData(pForm)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.disabled = false;
          btn.textContent = original;
          if (res.status && res.status !== 200) {
            btn.textContent = res.description || res.message || original;
            return;
          }
          refreshDrawer(true);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          pForm.submit();
        });
    });
  }

  /* ---------------------------------------------------------
     Quick add — any [data-quick-add][data-variant-id] button adds that
     variant straight to cart and opens the drawer. Used by bundle cards
     and anywhere else a product doesn't need its own detail-page visit.
     --------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-quick-add]'), function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      var original = btn.textContent;
      btn.disabled = true;

      fetch(cfg.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.disabled = false;
          if (res.status && res.status !== 200) {
            btn.textContent = res.description || res.message || original;
            setTimeout(function () { btn.textContent = original; }, 2200);
            return;
          }
          refreshDrawer(true);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
        });
    });
  });

  /* ---------------------------------------------------------
     Cart page: quantity steppers + remove
     --------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-cart-qty]'), function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.cartQty;
      var input = document.querySelector('[data-cart-input="' + key + '"]');
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.delta, 10));
      input.value = next;
      changeCart(key, next);
    });
  });

  Array.prototype.forEach.call(document.querySelectorAll('[data-cart-remove]'), function (btn) {
    btn.addEventListener('click', function () {
      changeCart(btn.dataset.cartRemove, 0);
    });
  });

  function changeCart(key, quantity, inDrawer) {
    return fetch(cfg.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // In the drawer we can repaint in place; on the cart page a reload
        // keeps line prices and discounts authoritative.
        if (inDrawer) renderDrawer(cart);
        else window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }
})();
